import React from "react";
import PropTypes from "prop-types";
import Pages from "features/pages";
import VoicemailProfile from "components/voicemail-profile";
import { selectors } from "reducers";
import { connect } from "react-redux";
import CircularProgress from "components/ui/circular-progress-bar";
import { voicemailMarkedWorked, setVoicemailPage } from "actions/auto-dialer";
import { VOICEMAILS_WRAPUP_TIME } from "reducers/auto-dialer";

function AutoDialerVoicemails({
  vmailIds,
  pageIndex,
  remainingTime,
  voicemailMarkedWorked,
  setVoicemailPage
}) {

  const handlePageChange = () => {
    setVoicemailPage(pageIndex + 1);
  };

  return (
    <Pages
      showNext={true}
      showPageNumber={true}
      containerStyle={{ padding: 20 }}
      showSelect={false}
      showBack={false}
      activePageIndex={pageIndex}
      onCustomPageChange={handlePageChange}
      pages={vmailIds.map((item, index) => ({
        title: `Voicemail ${index + 1}`,
        view: (
          <VoicemailProfile
            id={item}
            autoPlay={true}
            onWorked={() => voicemailMarkedWorked(item)}
          />
        )
      }))}
      customRender={
        <CircularProgress
          strokeWidth={5}
          size={28}
          percentage={(remainingTime / VOICEMAILS_WRAPUP_TIME) * 100}
          circleText={remainingTime > 5 ? " " : remainingTime}
          color={remainingTime > 5 ? "#25a8e0" : "red"}
        />
      }
    />
  );
}

AutoDialerVoicemails.propTypes = {
  vmailIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  pageIndex: PropTypes.number.isRequired,
  remainingTime: PropTypes.number.isRequired,
  voicemailMarkedWorked: PropTypes.func.isRequired,
  setVoicemailPage: PropTypes.func.isRequired
};

export default connect(
  state => ({
    vmailIds: selectors.getAutoDialerVoicemails(state),
    pageIndex: selectors.getAutoDialerVoicemailsPageIndex(state),
    remainingTime: selectors.getVoicemailRemainingTime(state)
  }),
  {
    voicemailMarkedWorked,
    setVoicemailPage
  }
)(AutoDialerVoicemails);
